import { ApplicationRef, Component, OnInit, ViewChild } from '@angular/core';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { NgxExtendedPdfViewerComponent } from 'ngx-extended-pdf-viewer';
import { RelatorioService } from '../relatorio.service';

@Component({
  selector: 'app-relatorio-visualizador',
  templateUrl: './relatorio-visualizador.component.html',
  styleUrls: ['./relatorio-visualizador.component.less']
})
export class RelatorioVisualizadorComponent implements OnInit {

  mostrarPdf: boolean = false;

  @ViewChild('modal', { static: true })
  modal!: DialogComponent;

  @ViewChild('pdf')
  pdf!: NgxExtendedPdfViewerComponent;

  arqPdf: Blob | string = '';

  titulo: string = 'Relatório';

  constructor(private appRef: ApplicationRef) { 
  }

  ngOnInit(): void {
  }

  abrirTelaCheia() {
      this.modal.show(true);
  }

  resetarArquivo() {
    this.arqPdf = '';
  }

  inserirArquivo(arq: Blob) {
    this.arqPdf = arq;
  }

  tratarFechamento() {
    let dialogs = document.body.querySelectorAll('ejs-dialog.e-popup-open');
    if(dialogs.length > 0) {
      document.body.classList.add('e-dlg-target');
      document.body.classList.add('e-scroll-disabled');
    }
  }  
}
